export const handelChange = (state, action) => {
  switch (action.type) {
    case "input": {
      // use regex directly
      const regex =
        action.regex instanceof RegExp
          ? action.regex
          : new RegExp(action.regex);

      return {
        ...state,
        [action.name]: action.value,
        [action.name + "Err"]: regex.test(action.value?.trim())
          ? "success"
          : action.value === ""
          ? "unchecked"
          : "error",
      };
    }

    case "Select": {
      return {
        ...state,
        [action.name]: action.value || "",
        [action.name + "Err"]: action.value ? "success" : "error",
      };
    }

    case "file": {
      return {
        ...state,
        [action.name]: action.value || "",
        [action.name + "Err"]: action.value ? "success" : "error",
      };
    }

    case "checkbox": {
      return {
        ...state,
        [action.name]: action.value,
      };
    }

    case "switch": {
      return {
        ...state,
        [action.name]: action.value,
      };
    }

    case "bulkUpdate": {
      const updatedState = { ...state };
      Object.keys(action.payload).forEach((key) => {
        updatedState[key] = action.payload[key];
        if (key.endsWith("Err")) {
          updatedState[key] = "success";
        } else {
          updatedState[`${key}Err`] = action.payload[key] ? "success" : "error";
        }
      });

      return updatedState;
    }
    case "Reset":
      return {};
    default:
      return state;
  }
};
